import { Alert, Button, DatePicker, Drawer, Form } from 'antd';
import { TruckSearchSelect } from '../../../../fleet/features/trucks/public/TruckSearchSelect';
import { useDeviceMappingSheet, type DeviceMappingFormValues } from '../hooks/use-device-mapping-sheet';
import { DevicePicker } from './DevicePicker';

interface DeviceMappingSheetProps {
  integrationId: string;
  /** Chosen already when the sheet opens from the unmapped devices list. */
  deviceId: string | undefined;
  onClose: () => void;
  onMapped: () => void;
}

/** Put one of this integration's devices on a truck from a date (blank: now). Ending a mapping and adding another is how a tracker swap is recorded. */
export function DeviceMappingSheet({ integrationId, deviceId, onClose, onMapped }: DeviceMappingSheetProps) {
  const sheet = useDeviceMappingSheet(integrationId, onMapped);

  return (
    <Drawer open onClose={onClose} title="Put a device on a truck" size={480}>
      {sheet.error && <Alert className="mb-5" type="error" showIcon title={sheet.error} />}
      <Form<DeviceMappingFormValues> layout="vertical" requiredMark={false} disabled={sheet.submitting} onFinish={sheet.save} initialValues={{ deviceId }}>
        <Form.Item name="deviceId" label="Device" rules={[{ required: true, message: 'Choose or enter a device' }]}>
          <DevicePicker devices={sheet.devices} />
        </Form.Item>
        <Form.Item name="truckId" label="Truck" rules={[{ required: true, message: 'Choose a truck' }]}>
          <TruckSearchSelect />
        </Form.Item>
        <Form.Item name="effectiveFrom" label="From" extra="Leave blank for now.">
          <DatePicker showTime className="w-full" />
        </Form.Item>
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" loading={sheet.submitting}>
            Map device
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
